import { ExpositorVideoPage } from './../pages/expositor-video/expositor-video';
import { Component, ViewChild, OnInit, HostListener } from '@angular/core';
import { Platform, MenuController, AlertController, App, NavController, Select, ToastController, LoadingController, ActionSheetController, ModalController, Events } from 'ionic-angular';
import { Splashscreen } from 'ionic-native';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { Network } from '@ionic-native/network'
import { StatusBar } from '@ionic-native/status-bar';
import { File } from '@ionic-native/file';
import { Transfer, TransferObject } from '@ionic-native/transfer';
import { FilePath } from '@ionic-native/file-path';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { Keyboard } from '@ionic-native/keyboard';
import { Router, ActivatedRoute, Params } from '@angular/router';
//Pages
import { TabsPage } from '../pages/tabs/tabs';
import { LoginPage } from '../pages/login/login';
import { HomePage } from '../pages/home/home';
import { AulasPage } from '../pages/aulas/aulas';
import { AtividadePage } from '../pages/atividade/atividade';
import { AgendaPage } from '../pages/agenda/agenda';
import { PalestrantesPage } from '../pages/palestrantes/palestrantes';
import { AjudaPage } from '../pages/ajuda/ajuda';
import { SobrePage } from '../pages/sobre/sobre';
//Models
import { User } from '../models/user.model';
import { Event, EventSelect } from '../models/event.model';
import { Congresso } from '../models/congresso.model';
import { ProfileImage } from '../models/profile-image.model';
import { Activity } from '../models/activity.model';
import { Lecturer } from '../models/lecturer.model';
import { DayProgram } from '../models/day-program.model';
import { Auth } from '../models/auth.model';
//Providers
import { CongressoProvider } from '../providers/congresso-provider';
import { UtilProvider } from '../providers/util-provider';
import { UserProvider } from '../providers/user-provider';
import { ConfigProvider } from '../providers/config-provider';
import { CalendarProvider } from '../providers/calendar-provider';
import { AuthProvider } from '../providers/auth-provider';
import { StorageProvider } from '../providers/storage-provider';
//Components
import { ThemeHelperComponent } from '../components/theme-helper/theme-helper.component';
import { CustomAlert } from '../components/custom-alert.component';

declare var cordova: any;

@Component({
  templateUrl: 'app.html'
})

export class Apc {


  public congressos: EventSelect[] = [];
  public congresso: EventSelect = new EventSelect();
  public storage = window.localStorage;
  public isCurrent: boolean;
  public base64Image: any;
  public userImgDefault: string;

  private lastImage: string = null;
  private locationHref: string = window.location.href;
  private _parameters: string[];
  private _userName: string;
  private _pass: string;
  private _year: number;

  private currentConfig: number = 0;
  private selectOptions = { mode: 'ios' };
  private config = [
    { Min: 10 },
    { Min: 20 },
    { Min: 30 }
  ];

  @ViewChild(NavController) nav: NavController;
  @ViewChild(Select) selectCongresso: Select;
  @ViewChild(ThemeHelperComponent) themeHelper: ThemeHelperComponent;

  //rootPage = this.checkLogged();

  pages: Array<{ id: number, title: string, icon: string }>;

  constructor(private platform: Platform,
    //public push: Push,
    private alertCtrl: AlertController,
    private menuCtrl: MenuController,
    private configProvider: ConfigProvider,
    private modalCtrl: ModalController,
    private statusBar: StatusBar,
    private keyboard: Keyboard,
    public events: Events,
    private app: App,
    private auth: AuthProvider,
    private congressoProvider: CongressoProvider,
    private userProvider: UserProvider,
    private utilProvider: UtilProvider,
    private storageProvider: StorageProvider,
    private camera: Camera,
    private transfer: Transfer,
    private file: File,
    private filePath: FilePath,
    private actionSheetCtrl: ActionSheetController,
    private toastCtrl: ToastController,
    private loadingCtrl: LoadingController,
    private alert: CustomAlert,
    private calendarProvider: CalendarProvider,
    private activatedRoute: ActivatedRoute,
    private network: Network,
    private inAppBrowser: InAppBrowser) {

    this.initializeApp();

    this.pages = [
      { id: 1, title: 'CONGRESSOS', icon: 'folder-open' },
      { id: 2, title: 'CONFIGURAÇÕES', icon: 'options' },
    ];

    this.userImgDefault = configProvider.IMAGE_DEFAULT;

    this.utilProvider.checkConnection();
    //setTimeout(() => { this.connected = this.utilProvider.isConnected(false)}, 6000)

    events.subscribe('user:login', () => {
      this.login();
    });

    events.subscribe('page:reload', () => {
      this.reLoadPage();
    });


  }

  onOpen() {
    this.congresso = JSON.parse(localStorage.getItem('congresso')) as EventSelect;
    this.selectCongresso.writeValue(this.congresso.Id);
    this.currentConfig = +localStorage.getItem('config') ? +localStorage.getItem('config') : 0;
    this.nav = this.app.getActiveNav();
  }

  startNg() {
    let self = this;
    self.formatParams();
    //if (!this.utilProvider.isConnected(false) && this.utilProvider.isFirstAccess()) {
    //  this.alert.showAlertWithCallback('Sem conexão com a internet', this.utilProvider.getNoConnectedMessage(), 'Atualizar', () => { setTimeout(() => {self.ngOnInit()}, 3000); });
    //}
    //else  if (this.utilProvider.isConnected(false) && this.utilProvider.isFirstAccess()) {

    this.congressoProvider.GetAll().then(result => {
      result.forEach(element => {
        if (element.Id < 13) //13 = 2021: Ajuste feito para manter o APC em funcionamento, pois não suporta os eventos a partir de 2021
          this.congressos.push(element);
      });

      localStorage.setItem('congressos', this.congressos ? JSON.stringify(this.congressos) : "");
      //if (!localStorage.getItem('congresso'))
      localStorage.setItem('congresso', this.congressos[0] ? JSON.stringify(this.congressos[0]) : "");

      this.storageProvider.clear('lastRefreshDate');
      this.storageProvider.clear('programacaoAtual');
      this.storageProvider.clear('atividadesDia');

      if (localStorage.getItem('user'))
        this.auth.user = JSON.parse(localStorage.getItem('user'));
      else this.auth.user = null;

      localStorage.setItem('config', localStorage.getItem('config') ? localStorage.getItem('config') : "0");
      let congress = JSON.parse(localStorage.getItem('congresso')) as Congresso
      this.isCurrent = congress.Ano == this.configProvider.ANO_ATUAL || congress.Liberado;

      this.setColors(congress);
      self.app.getRootNav().setRoot(TabsPage);

      if (this._parameters.length > 1)
        this.loginByAdmin();
      else if (this._year) {
        let ano = this._year ? this._year : this.configProvider.ANO_ATUAL;
        let congressos = JSON.parse(localStorage.getItem('congressos'));
        let congressoEnviado = congressos.filter(x => x.Ano == ano)[0] as Congresso;
        this.onSelectCongress(congressoEnviado.Id);
      }

    })
      .catch(error => {
        this.alert.showAlert('Erro', 'Ocorreu um erro ao recuperar informações dos congressos. ');

        if (localStorage.getItem('congressos')) {

          if (localStorage.getItem('user'))
            this.auth.user = JSON.parse(localStorage.getItem('user'));
          else this.auth.user = null;

          localStorage.setItem('config', localStorage.getItem('config') ? localStorage.getItem('config') : "0");
          let congress = JSON.parse(localStorage.getItem('congresso')) as Congresso
          this.isCurrent = congress.Ano == this.configProvider.ANO_ATUAL || congress.Liberado;

          this.setColors(congress);
          self.app.getRootNav().setRoot(TabsPage);

          if (this._parameters.length > 1)
            this.loginByAdmin();
          else if (this._year) {
            let ano = this._year ? this._year : this.configProvider.ANO_ATUAL;
            let congressos = JSON.parse(localStorage.getItem('congressos'));
            let congressoEnviado = congressos.filter(x => x.Ano == ano)[0] as Congresso;
            this.onSelectCongress(congressoEnviado.Id);
          }
        }

      });

    //}
    //else{
    //  this.congressos = localStorage.getItem('congressos') ? JSON.parse(localStorage.getItem('congressos')) as Array<EventSelect> : new Array<EventSelect>();
    //  if (localStorage.getItem('user'))
    //      this.auth.user = JSON.parse(localStorage.getItem('user'));
    //  else this.auth.user = null;

    //}
  }

  initializeApp() {
    this.platform.ready().then(() => {

      this.statusBar.styleDefault()
      this.statusBar.backgroundColorByHexString('#000');
      Splashscreen.hide();
      this.startNg();
      this.utilProvider.onResize(this.platform.width());
      /*let disconnectSub = this.network.onDisconnect().subscribe(() => {
          this.connected = false;
          this.alert.showAlert('teste','disconect');
      });

      let connectSub = this.network.onConnect().subscribe(() => {
          setTimeout(()=>{
            if (this.network.type !== 'none'){
              this.connected = true;
              this.alert.showAlert('teste','connected');
            }
          }, 3000)

      });*/

      //this.utilProvider.checkConnection();

      if (this.utilProvider.getPlatform() == 'ios') {
        this.keyboard.hideKeyboardAccessoryBar(false);
      }

    });
  }

  @HostListener('window:resize', ['$event'])
  private onResize(event: any) {
    this.utilProvider.onResize(event.target.innerWidth);
  };

  checkLogged(): any {
    var self = this;

    //this.utilProvider.checkConnection();



    if (localStorage.getItem('firstAccess') === "undefined" ||
      localStorage.getItem('firstAccess') === 'true' ||
      localStorage.getItem('firstAccess') === null) {
      localStorage.setItem('firstAccess', 'true');
      return TabsPage;
    }

    let congressos = JSON.parse(localStorage.getItem('congressos'));

    if (congressos)
      localStorage.setItem('congresso', congressos[0] ? JSON.stringify(congressos[0]) : "");
    else {
      this.congressoProvider.GetAll().then(result => {
        result.forEach(element => {
          this.congressos.push(element);
        });

        localStorage.setItem('congresso', congressos[0] ? JSON.stringify(congressos[0]) : "");

      }).catch(error => {
        this.alert.showAlert('Erro', 'Ocorreu um erro ao recuperar informações dos congressos. ');

        if (localStorage.getItem('congressos')) {

          if (localStorage.getItem('user'))
            this.auth.user = JSON.parse(localStorage.getItem('user'));
          else this.auth.user = null;

          localStorage.setItem('config', localStorage.getItem('config') ? localStorage.getItem('config') : "0");
          let congress = JSON.parse(localStorage.getItem('congresso')) as Congresso
          this.isCurrent = congress.Ano == this.configProvider.ANO_ATUAL || congress.Liberado;

          this.setColors(congress);
          self.app.getRootNav().setRoot(TabsPage);

          if (this._parameters.length > 1)
            this.loginByAdmin();
          else if (this._year) {
            let ano = this._year ? this._year : this.configProvider.ANO_ATUAL;
            let congressos = JSON.parse(localStorage.getItem('congressos'));
            let congressoEnviado = congressos.filter(x => x.Ano == ano)[0] as Congresso;
            this.onSelectCongress(congressoEnviado.Id);
          }
        }

      });
    }

    window.addEventListener('message', self.receiveMessage.bind(self), false);

    return TabsPage;
  }
  _self = this;
  receiveMessage(e) {
    let congressos = JSON.parse(localStorage.getItem('congressos'));
    let self = this;

    // Checa o ano enviado pelo sgun
    if (e && e.data || this._year) {

      let ano = e && e.data ? e.data : this._year;
      localStorage.setItem('congresso', congressos ? JSON.stringify(congressos.filter(x => x.Ano == ano)[0]) : "");
      var congresso = congressos.filter(x => x.Ano == ano);
      var id = congresso[0].Id;
      this.onSelectCongress(id);
    }
  }

  formatParams() {
    this._parameters = this.locationHref.split('cpf=');

    this._userName = this.getParameterByName('cpf', this.locationHref);
    this._pass = this.getParameterByName('token', this.locationHref);
    this._year = Number(this.getParameterByName('ano', this.locationHref));
  }

  getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  logout() {
    var self = this;
    self.menuCtrl.close();

    let confirm = this.alertCtrl.create({
      title: 'Sair',
      message: 'Deseja sair?',
      buttons: [{
        text: 'Sim',
        handler: () => {
          this.auth.user = null;

          localStorage.removeItem('user');
          localStorage.removeItem('atividadesInscritas');
          localStorage.removeItem('atividadesAssistidas');
          localStorage.removeItem('palestrantesFavoritos');
          localStorage.removeItem('agenda');

          this.nav.last()._didEnter();

        }
      }, {
        text: 'Não',
        handler: () => { }
      }],
    });

    confirm.present();
  }

  onSelectCongress(congressoId: any) {

    this.congressos = JSON.parse(localStorage.getItem('congressos'));
    let congresso = this.congressos[0] as Congresso;

    if (congressoId > 0)
      congresso = this.congressos.filter(x => x.Id == congressoId)[0] as Congresso

    let connected = this.utilProvider.isConnected(true);

    if (connected || congressoId == this.congressos[0].Id) {

      this.storage.setItem('congresso', congresso ? JSON.stringify(congresso) : "");
      this.storage.removeItem('filter');
      this.storage.removeItem('atividadesDia');
      this.storage.removeItem('palestrantes');
      this.storage.removeItem('lastRefreshDate');

      this.setColors(congresso);

      let tab = this.app.getRootNav().getActiveChildNav();

      if (this.isCurrent && tab.selectedIndex == 2)
        tab.selectedIndex = "0";

      this.app.getRootNav().setRoot(TabsPage, { id: tab.selectedIndex });

      this.menuCtrl.close();
    }
    else {
      this.selectCongresso.writeValue(this.congressos[0].Id);

      let atuais = JSON.parse(localStorage.getItem('programacaoAtual')) as Array<DayProgram>;
      this.storageProvider.set('atividadesDia', atuais);
      let palestrantes = new Array<Lecturer>();
      atuais.forEach((x) => {
        Array.prototype.push.apply(palestrantes, x.Palestrantes);
      });
      let lastRefreshDate = new Date().toISOString();
      this.storage.setItem('lastRefreshDate', lastRefreshDate);
      localStorage.setItem('palestrantes', palestrantes ? JSON.stringify(palestrantes.filter((thing, index, self) => self.findIndex((t) => { return t.Nome === thing.Nome; }) === index).sort()) : '');
      this.isCurrent = true;
    }

    return false;
  }

  onSelectConfig(configId: string) {

    localStorage.setItem('config', configId ? configId : "0");

    if (+configId > 0) {
      this.calendarProvider.create('', '').then(() => {
        let activitiesIds = JSON.parse(localStorage.getItem('atividadesInscritas')) as number[];
        if (activitiesIds != undefined && activitiesIds.length != 0) {

          this.calendarProvider.removeActivities(activitiesIds, false);
          this.calendarProvider.addActivitiesRecursive(activitiesIds);
        }
      },
        (err) => {
          localStorage.setItem('config', "0");
        });
    }
    else {
      this.calendarProvider.remove();
    }
    this.menuCtrl.close();
  }

  platformIsHigh() {
    return this.platform.height() > 600;
  }

  setColors(congresso: Congresso) {
    if (congresso.CorPrimaria) {
      this.themeHelper.setProperty('primary', congresso.CorPrimaria);
      this.themeHelper.setProperty('primary-lower-op', this.utilProvider.hexToRgbA(congresso.CorPrimaria, 0.8));
      this.themeHelper.setProperty('primary-high-op', this.utilProvider.hexToRgbA(congresso.CorPrimaria, 0.45));
    }
    if (congresso.CorSecundaria) {
      this.themeHelper.setProperty('secondary', congresso.CorSecundaria);
      this.themeHelper.setProperty('secondary-lower-op', this.utilProvider.hexToRgbA(congresso.CorSecundaria, 0.8));
    }
    if (congresso.CorTerciaria) {
      this.themeHelper.setProperty('tertiary', congresso.CorTerciaria);
      this.themeHelper.setProperty('tertiary-lower-op', this.utilProvider.hexToRgbA(congresso.CorTerciaria, 0.8));
      this.themeHelper.setProperty('tertiary-lower-op', this.utilProvider.hexToRgbA(congresso.CorTerciaria, 0.8));
    }
  }

  getInfoUser(name?: string): string {
    
    this.auth.user = JSON.parse(localStorage.getItem('user'));
    if (name === "nome") {
      return this.auth.user ? this.auth.user.ReducedName : '---';
    }
    if (name === "categoria") {
      return this.auth.user ? this.auth.user.Categoria : '---';
    }
    if (name === null || name === undefined) {
      if (this.auth.user === null || this.auth.user === undefined) {
        return "assets/images/image-perfil.png";
      }
      else {
        return this.auth.user.PathFoto;
      }
    }
    return
  }

  getPhoto() {
    if (this.auth.isAuthorized()) {
      let actionSheet = this.actionSheetCtrl.create({
        title: 'Seletor de imagem',
        buttons: [
          {
            text: 'Carregar da galeria',
            handler: () => {
              this.takePicture(this.camera.PictureSourceType.PHOTOLIBRARY);
            }
          },
          {
            text: 'Usar camera',
            handler: () => {
              this.takePicture(this.camera.PictureSourceType.CAMERA);
            }
          },
          {
            text: 'Cancelar',
            role: 'cancel'
          }
        ]
      });
      actionSheet.present();
    }
  }

  takePicture(selectedSourceType) {
    let options: CameraOptions = {
      quality: 100,
      allowEdit: true,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      sourceType: selectedSourceType,
      saveToPhotoAlbum: true,
    }


    if (this.utilProvider.isConnected(true)) {

      this.camera.getPicture(options).then((imagePath) => {

        let profileImg = this.createProfileImage(imagePath)

        this.userProvider.getProfileImage(profileImg).then((data) => {

          data = JSON.parse(data);

          if (data.resposta.codigo == 0) {
            let pathFotoBg = this.utilProvider.toBackground('data:image/jpeg;base64,' + profileImg.Base64);
            this.auth.user.PathFoto = 'data:image/jpeg;base64,' + imagePath;
          }
          else
            this.alert.showAlert(data.resposta.retorno[0].error, 'Erro');
        }).catch(response => {
          let err = response;
          if (err) {
            this.utilProvider.loadingHide();
            this.alert.showAlert('Atenção', err);
          }
        });
      }, (err) => {
        this.alert.showAlert('Erro', 'Erro ao selecionar a imagem.');
      });
    }
  }

  private createProfileImage(imagePath: any): ProfileImage {
    var profileImage: ProfileImage = {
      Base64: imagePath,
      Extension: '.jpeg',
      UsuarioId: this.auth.user.SgunId,
      UsuarioLogin: this.auth.user.Login
    }
    return profileImage;
  }

  login() {
    this.menuCtrl.close();
    let modal = this.modalCtrl.create(LoginPage);
    modal.present();
  }

  loginByAdmin() {

    let self = this;
    let connected = self.utilProvider.isConnected(true);
    if (connected) {
      self.utilProvider.loadingShow();

      var authModel = {
        UserName: this._userName,
        Password: this._pass,
        LoginByAdmin: true,
      } as Auth;

      self.auth.loginByAdmin(authModel)
        .then((data) => {

          let ano = this._year ? this._year : this.configProvider.ANO_ATUAL;
          let congressos = JSON.parse(localStorage.getItem('congressos'));
          if (congressos)
            localStorage.setItem('congresso', congressos ? JSON.stringify(congressos.filter(x => x.Ano == ano)[0]) : "");

          this.userProvider.getAtividadesInscritasIdsUsuario(data.Guid, ano)
            .then(d => {

              if (d)
                localStorage.setItem('atividadesInscritas', JSON.stringify(d))
            });

          this.userProvider.getAtividadesAssistidasIdsUsuario(data.Guid, ano)
            .then(d => {

              if (d)
                localStorage.setItem('atividadesAssistidas', JSON.stringify(d))
            });

          this.userProvider.getPalestrantesFavoritos(data.Guid, ano)
            .then(r => {

              if (r)
                localStorage.setItem('palestrantesFavoritos', JSON.stringify(r.resposta.retorno))
            });

          this.utilProvider.loadingHide();
          this.setColors(congressos.filter(x => x.Ano == ano)[0])
          this.reLoadPage();
        })
        .catch(response => {
          self.utilProvider.loadingHide();
        });
    }
    return false;
  }

  isLogged() {
    return localStorage.getItem('user') ? true : false;
  }

  showAjuda() {
    // this.menuCtrl.close();
    // let modal = this.modalCtrl.create(AjudaPage);
    // modal.present();

    if (this.utilProvider.isConnected(true)) {
      let modal = this.modalCtrl.create(ExpositorVideoPage, {
        id: 17,
        urlVideo: "https://vimeo.com/449432920",
        titlePage: 'AJUDA'
      });
      modal.present();
    }
    //TODO: Trocar url 
    //this.openUrl("https://www.youtube.com/watch?v=Ew6lngNUhdQ", false);
  }

  showSobre() {
    this.menuCtrl.close();
    let modal = this.modalCtrl.create(SobrePage);
    modal.present();
  }

  selectOpen() {
    if (!this.auth.isAuthorized()) {
      return false;
    }
  }

  closeMenu() {
    this.menuCtrl.close();
  }

  reLoadPage() {
    let tab = this.app.getRootNav().getActiveChildNav();
    this.app.getRootNav().setRoot(TabsPage, { id: tab.selectedIndex });
  }


  openUrl(url, inNativeBrowser) {
    if (this.utilProvider.isNullOrEmpty(url) || url == '#')
      return false;

    if (inNativeBrowser) {

      const browser = this.inAppBrowser.create(url, '_blank', "location=yes,toolbar=yes,hidden=no");
      browser.show();

    } else {
      const browser = this.inAppBrowser.create(url, '_blank', "location=yes,toolbar=yes,hidden=no");
      browser.show();
    }
  }

  onLink(url: string) {
    window.open(url);
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts